import LayoutContainer from 'components/Common/LayoutContainer'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Spacing from 'components/Common/Spacing'
import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'
import Accordion from 'components/Luxkit/Accordion'

interface Props {
  title: string;
  content: Array<App.LegalItem>;
}

function HubLegal(props: Props) {
  return (
    <LayoutContainer size="sm">
      <Heading as="h2" variant="heading2">{props.title}</Heading>
      {props.content.map((item) => (
        <Spacing key={item.type} mt={16}>
          {item.type === 'legalTermAndCondition' && (
            <div key={item.fields.slug} id={item.fields.slug}>
              <Heading as="h2" variant="heading2">{item.fields.title}</Heading>
              <Spacing mt={24}>
                <MarkdownRender content={item.fields.description} />
              </Spacing>
            </div>
          )}
          {item.type === 'legalPageFaq' && (
            <Accordion
              key={item.fields.slug}
              heading={item.fields.title}
              id={item.fields.slug}
            >
              <MarkdownRender content={item.fields.answer} />
            </Accordion>
          )
        }
        </Spacing>
      ))}
    </LayoutContainer>
  )
}

export default HubLegal
